import { render } from "./IngresoCapitulos.vue?vue&type=template&id=b7668af4&scoped=true"
import script from "./IngresoCapitulos.vue?vue&type=script&lang=js"
export * from "./IngresoCapitulos.vue?vue&type=script&lang=js"

import "./IngresoCapitulos.vue?vue&type=style&index=0&id=b7668af4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7668af4"]])

export default __exports__